import getUrlQueries from "./modules/get_url_queries";

jQuery(document).on("turbolinks:load", function(){
  // デモ環境ではない場合はコメントアウト ↓
  $("input[type='submit']").click(e => {
    if (!e.target.value.includes("検索") && !e.target.value.includes("ログイン")) {
      alert("デモ環境ではデータの作成/変更はできません。")
      return false;
    }
  })
  //
  // デモ環境ではない場合はコメントアウト ↓
  $("a[data-method='delete']").click(e => {
    if (e.target.text != "logoutログアウト") {
      alert("デモ環境ではデータに変更を加えることはできません。")
      return false;
    }
  })

  $(".l-header_hamburger").on("click", function(){
    $(".l-header_hamburger_icon").toggleClass("l-header_hamburger_close");
    $(".l-header_nav").slideToggle();
  });

  $("#sign_in_users_table > tbody > tr").on("click", function(){
    $("input[name='user[email]']").val($(this).data().email)
    $("input[name='user[password]']").val("Password0")
    $("form[id='new_user']").submit()
  })
  
  // 表示件数セレクトボックス変更時
  $('.select_per_page').change(e => {
    const queries = getUrlQueries();
    console.log("aaa")
    queries.per_page = e.target.value;
    let query_strings_array = [];
    Object.keys(queries).forEach(key => query_strings_array.push(`${key}=${queries[key]}`));
    window.location.href = `${window.location.origin}${window.location.pathname}?${query_strings_array.join("&")}`;
  })
  
  $("#user_profile_image").uploadThumbs({
    position: "#user_profile_image_preview"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });

  $("#matching_service_image_2").uploadThumbs({
    position: "#matching_service_image_preview_2"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });

  $("#matching_service_image_1").uploadThumbs({
    position: "#matching_service_image_preview_1"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });

  $("#matching_service_image_2").uploadThumbs({
    position: "#matching_service_image_preview_2"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });

  $("#reserve_service_image_3").uploadThumbs({
    position: "#reserve_service_image_preview_3"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });
  
  $("#reserve_service_image_1").uploadThumbs({
    position: "#reserve_service_image_preview_1"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });

  $("#reserve_service_image_3").uploadThumbs({
    position: "#reserve_service_image_preview_3"     // 0:before, 1:after, 2:parent.prepend, 3:parent.append,
  });
  
  // $("#calendarField").datepicker( { dateFormat: "yy-mm-dd" } );
});
